import { createContext } from "react";

import { ContextContextTypes } from "./types";

export const ContextContext = createContext<ContextContextTypes | undefined>(undefined);
ContextContext.displayName = "ContextContext";
